"use client";

import { createContext, useContext } from "react";
import type { PaymentType } from "react-svg-credit-card-payment-icons";

export interface CardNetworkContextValue {
  type: PaymentType;
  cvvSize: number;
  maxCardLength: number;
}

const DEFAULT_VALUE: CardNetworkContextValue = {
  type: "Generic",
  cvvSize: 4,
  maxCardLength: 19,
};

export const CardNetworkContext =
  createContext<CardNetworkContextValue>(DEFAULT_VALUE);

export function useCardNetworkContext(): CardNetworkContextValue {
  return useContext(CardNetworkContext);
}
